import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InviteSessionStorageService {
  private showLoginKey = 'showLoginFormOnce';

  private skipPrefillKey = 'skipInvitePrefill';

  sessionStorage: Storage = sessionStorage;

  setShowLoginOnce(): void {
    this.sessionStorage.setItem(this.showLoginKey, 'true');
  }

  getShowLoginOnce(): boolean {
    const shouldShow = this.sessionStorage.getItem(this.showLoginKey) === 'true';
    if (shouldShow) this.sessionStorage.removeItem(this.showLoginKey);
    return shouldShow;
  }

  setSkipPrefill(hash: string): void {
    this.sessionStorage.setItem(this.skipPrefillKey, hash);
  }

  getSkipPrefill(): string | null {
    return this.sessionStorage.getItem(this.skipPrefillKey);
  }

  clearSkipPrefill(): void {
    this.sessionStorage.removeItem(this.skipPrefillKey);
    this.sessionStorage.removeItem(this.showLoginKey);
  }
}
